import Action, { GetContext, } from './Action';
export default class Exit extends Action {
    constructor(messageBody) {
        super();
        this.messageBody = messageBody;
        this[GetContext] = this.getExitContext.bind(this);
    }
    getExitContext() {
        return { messageBody: this.messageBody };
    }
}
